import React, { Component } from 'react'
import './style.css'
import { connect } from 'react-redux'
import Card from '../components/card/card'
import NavBar from '../components/navBar/navBar'
import { HideCard, ShowCard } from '../../src/actions'
import PDF from '../../src/DataProtection(GDPR).pdf'

class ContactPage extends Component {

   constructor(props) {
        super(props)
        this.state = {
           name: '',
           phone: '',
           email: '',
           city: '',
           subject: '',
           message: '',
           checkbox: false,
           nameClass: 'input-contactPage',
           phoneClass: 'input-contactPage',
           emailClass: 'input-contactPage',
           cityClass: 'input-contactPage',
           subjectClass: 'inputSelecter-contactPage',
           messageClass: 'messageInput-contactPage',
        }
       document.title = 'JustLegal | Contact'
   }

   goodToKnowTitle = () => {
       switch(this.props.language) {
            default:
                return 'Good to know'
       }
   }

   letsGetStartedTitle = () => {
       switch(this.props.language) {
            default:
                return "Let's get started"

       }
   }

   goodToKnowText = () => {
    switch(this.props.language) {
        default:
            return 'Just legal is not a law firm if you need legal representation in front of a judicial institution to contact us and get a reference to one of our trusted partners. Here at Just legal, we aim to establish a community platform for expats where administrative, legal and financial issues can be resolved. The first year of relocation, for any person, can lead to a number of issues and complications. Our solutions have been repaired by expats, which managed to fully integrate both academically and professionally in the Netherlands. Get in touch and let’s talk.'
        }
    }

    letsGetStartedText = () => {
        switch(this.props.language) {
            default:
                return 'You can contact us from any place by using our contact form. After you present your issue to us we will get back to you with a short (free of charge) recommendation and a list of possible actions. We believe that the majority of problems people face are due to lack of information. Sharing our knowledge with you could lead to a quick fix and better results. If the nut proves too hard to crack, we can get actively involved and prepare a solution. Write down your problem and let’s talk.'

        }
    }

    namePlaceholder = () => {
        switch(this.props.language) {
            default:
                return 'Name'
        }
    }

    phonePlaceholder = () => {
        switch(this.props.language) {
            default:
                return 'Phone number'
        }
    }

    emailPlaceholder = () => {
        switch(this.props.language) {
            default:
                return 'Email'
        }
    }

    cityPlaceholder = () => {
        switch(this.props.language) {
            default:
                return 'City'
        }
    }

    subjectOption0 = () => {
        switch(this.props.language) {
            default:
                return 'Select subject'
        }
    }

    subjectOption1 = () => {
        switch(this.props.language) {
            default:
                return 'Relocation Assistance'
        }
    }

    subjectOption2 = () => {
        switch(this.props.language) {
            default:
                return 'Administrative Support & Consultation'
        }
    }

    subjectOption3 = () => {
        switch(this.props.language) {
            default:
                return 'Lease Agreement Review'
        }
    }

    subjectOption4 = () => {
        switch(this.props.language) {
            default:
                return 'Other - Please specify'
        }
    }

    messagePlaceholder = () => {
        switch(this.props.language) {
            default:
                return 'Message'
        }
    }

    sendButtonText = () => {
        switch(this.props.language) {
            default:
                return 'Send'
        }
    }

    termsAndConditions = () => {
        let text, linkText
        switch(this.props.language) {
            default:
                text = 'I accept the'
                linkText = 'Terms and Conditions.'
        }
        return (
            <div className={'checkboxText-contactPage'}>
                {text} <a href={PDF} target={'_blank'} className={'termsConditions-contactPage'}>{linkText}</a> 
            </div>
        )
    }

    alertText = () => {
        switch(this.props.language) {
            default:
                // return This policy is part of the general terms of the website <just-legal.nl>.

                // By clicking continue you agree that we shall administer the personal data you provide to us. Providing any personal data is voluntary. 
                
                // Your personal information will not be disclosed to third parties, except in connection with the successful execution of the services chosen by you. Prior to a submission of your information to legally authorized persons or institutions you shall receive a notification.
                
                // We can use automatically collected information for statistical purposes, in order to improve our services. We can reveal, correct and delete your personal data at your written request. 
                
                // Please contact us if you have questions related to our data protection policy.
                
        }
    }

    onNameInput = (e) => {
        this.setState({name: e.target.value})
    }

    onPhoneInput = (e) => {
        this.setState({phone: e.target.value})
    }

    onEmailInput = (e) => {
        this.setState({email: e.target.value})
    }

    onCityInput = (e) => {
        this.setState({city: e.target.value})
    }

    onSubjectInput = (e) => {
        this.setState({subject: e.target.value})
    }

    onMessageInput = (e) => {
        this.setState({message: e.target.value})
    }

    onCheckboxInput = (e) => {
        this.setState({checkbox: !this.state.checkbox})
    }

    onFormSubmit = (e) => {
        if(!this.formValidation()) {
            e.preventDefault()
            return 
        }
    }

    formValidation = () => {
        this.setState({
            nameClass: 'input-contactPage',
            phoneClass: 'input-contactPage',
            emailClass: 'input-contactPage',
            cityClass: 'input-contactPage',
            subjectClass: 'inputSelecter-contactPage',
            messageClass: 'messageInput-contactPage',
        })
        let flag = true
        if(!this.state.name) {
            flag = false
            this.setState({nameClass: this.state.nameClass + ' onInputUnvalidated-contactPage'})
        }
        if(!this.state.phone) {
            flag = false
            this.setState({phoneClass: this.state.phoneClass + ' onInputUnvalidated-contactPage'})
        }
        if(!this.state.email) {
            flag = false
            this.setState({emailClass: this.state.emailClass + ' onInputUnvalidated-contactPage'})
        }
        if(!this.state.city) {
            flag = false
            this.setState({cityClass: this.state.cityClass + ' onInputUnvalidated-contactPage'})
        }
        if(!this.state.subject) {
            flag = false
            this.setState({subjectClass: this.state.subjectClass + ' onInputUnvalidated-contactPage'})
        }
        if(this.state.subject === 'Other' && !this.state.message) {
            flag = false
            this.setState({messageClass: this.state.messageClass + ' onInputUnvalidated-contactPage'})
        }
        
        if(!this.state.checkbox && flag) {
            flag = false
            alert(this.alertText())
        }
        return flag
    }

    render() {
        return(
            <div className={'page page-contactPage ' + (this.props.cardView ? 'noscroll' : '')}>
               
                <div className={'info-contactPage'}>
                    <div className={'paragraphs-contactPage'}>
                        <h1 className={'title-contactPage'}>{this.goodToKnowTitle()}</h1>
                        <div className={'text-contactPage'}>{this.goodToKnowText()}</div>
                    </div>

                    <div className={'paragraphs-contactPage'}>
                        <h1 className={'title-contactPage'}>{this.letsGetStartedTitle()}</h1>
                        <div className={'text-contactPage'}>{this.letsGetStartedText()}</div>
                    </div>
                </div>          

                <form onSubmit={this.onFormSubmit} className={'form-contactPage'}>
                    <div className={'formContainer-contactPage'}>
                        <div className={'inputContainer-contactPage'}>
                            <input type={'text'} value={this.state.name} onChange={this.onNameInput}
                            placeholder={this.namePlaceholder()} className={this.state.nameClass}/>

                            <input type={'tel'} value={this.state.phone} onChange={this.onPhoneInput}
                            placeholder={this.phonePlaceholder()} className={this.state.phoneClass}/>

                            <input type={'email'} value={this.state.email} onChange={this.onEmailInput}
                            placeholder={this.emailPlaceholder()} className={this.state.emailClass}/>

                            <input type={'text'} value={this.state.city} onChange={this.onCityInput}
                            placeholder={this.cityPlaceholder()} className={this.state.cityClass}/>

                            <select value={this.state.subject} onChange={this.onSubjectInput}
                            className={this.state.subjectClass}>
                                <option value={''}>{this.subjectOption0()}</option>
                                <option value={'Relocation Assistance'}>{this.subjectOption1()}</option>
                                <option value={'Administrative Support & Consultation'}>{this.subjectOption2()}</option>
                                <option value={'Lease Agreement Review'}>{this.subjectOption3()}</option>
                                <option value={'Other'}>{this.subjectOption4()}</option>
                            </select>

                        </div>
                    
                        <textarea type="text" value={this.state.message} onChange={this.onMessageInput}
                        placeholder={this.messagePlaceholder()} className={this.state.messageClass}/>

                    </div>

                    <div className={'checkboxContainer-contactPage'}>
                        <input type={'checkbox'} value={this.state.checkbox} onChange={this.onCheckboxInput}/>
                        {this.termsAndConditions()}
                    </div>

                    <input type={'submit'} value={this.sendButtonText()} className={'inputButton-contactPage'}
                    ref={(ref) => this.sendButtonRef=ref}/>
                </form>

                 <NavBar language={this.props.language} page={'contact'} 
                showCard={() => this.props.dispatch(ShowCard())}/>     
            
                <Card cardView={this.props.cardView} language={this.props.language} 
                hideCard={() => this.props.dispatch(HideCard())}/>
            </div>
        )
    }
}

const mapStateToProps = (state) =>({
    language: state.language,
    cardView: state.cardView,
})
export default connect(mapStateToProps)(ContactPage)


// WEBPACK FOOTER //
// ./src/ui/contactPage/contactPage.js